import { createSelector } from "@ngrx/store"

import { createConfigSelector } from '../../state/branding.store';
import { selectJob } from '../job-tool.reducer';

export const selectJobClosedReason = createSelector(
	createConfigSelector('JOBS_CLOSEDREASONS'),
	selectJob,
	(closedReasons, job) => {
		const reason = closedReasons.find((c) => c.id === job?.closedReason);

		return reason?.title || job?.closedReason;
	},
);
